module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-calendario-ima-perfonalizado.8427ad7a.jpg";